'use client';

import { CONSENT_EVENTS } from '@repo/analytics';
import { ga4GtagAdapter } from '@repo/web-chrome/lib/analytics/ga4-gtag-adapter';
import { updateConsent } from '@repo/web-chrome/lib/analytics/update-consent';
import {
  COOKIE_CONSENT_KEY,
  isMobileDevice,
  resolveGeoConsentRequired,
} from '@repo/web-chrome/lib/cookie-consent';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const CookieConsentBanner = dynamic(
  () => import('./cookie-consent-banner').then((mod) => mod.CookieConsentBanner),
  { ssr: false },
);

function alreadyDecided(): boolean {
  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    return stored === 'accepted' || stored === 'rejected';
  } catch {
    return false;
  }
}

function autoAccept(): void {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
  } catch {}
  updateConsent(true);
  ga4GtagAdapter.track(CONSENT_EVENTS.granted);
}

export function CookieConsentBannerLoader(): React.JSX.Element | null {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (alreadyDecided()) {
      return;
    }
    if (isMobileDevice()) {
      autoAccept();
      return;
    }
    let cancelled = false;
    resolveGeoConsentRequired().then((required) => {
      if (cancelled) {
        return;
      }
      if (required) {
        setShowBanner(true);
      } else {
        updateConsent(true);
        ga4GtagAdapter.track(CONSENT_EVENTS.granted);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!showBanner) {
    return null;
  }
  return <CookieConsentBanner />;
}
